import api from "../http/api";

export const checkApiHealth = async () => {
  try {
    const response = await fetch(
      "https://academetrics-back-dev.azurewebsites.net/health"
    );
    if (response.ok) {
      const data = await response.json();
      return data.status;
    } else {
      return "Offline";
    }
  } catch (error) {
    return "Erro ao conectar";
  }
};

export const loginUser = async (email, password) => {
  try {
    const response = await api.client.post("api/v1/Login", {
      email: email,
      password: password
    });

    if (response.status !== 200) {
      return response.data;
    }

    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      return error.response.data;
    }
    throw new Error("Falha na conexão com a API de login");
  }
};

export const forgotPassword = async (email, password) => {
  try {
    const response = await api.client.post("api/v1/ForgotPassword", {
      email,
      password
    })

    if (response.status !== 202) {
      throw new Error("Erro ao realizar login")
    }

    return response.data
  } catch (error) {
    if (error.response && error.response.status === 404) {
      throw new Error("O E-mail não existe. Por favor, crie um usuário")
    }
    throw new Error("Falha na conexão com a API de login")
  }
}


export const createUser = async (user) => {
  try {
    const response = await api.client.post("api/v1/CreateUser", user);

    return response.data;
  } catch (error) {
    throw new Error("Falha na conexão com a API de criação de usuário");
  }
};

export const readByUser = async () => {
  try {
    const response = await api.client.get("api/v1/ReadByUserId");

    return response.data;
  } catch (error) {
    return null;
  }
};

export const readUserById = async (userId) => {
  try {
    const response = await api.client.get(`api/v1/ReadUserById/${userId}`);

    return response.data;
  } catch (error) {
    return null;
  }
};

export const readByInstitution = async (id) => {
  try {
    const response = await api.client.get(`api/v1/ReadByInstitutionId/${id}`);

    return response.data;
  } catch (error) {
    return null;
  }
};

export const listUsers = async () => {
  try {
    const response = await api.client.get("api/v1/ReadUser");

    return response.data;
  } catch (error) {
    return null;
  }
};

export const createInstitution = async (institution) => {
  try {
    const response = await api.client.post("api/v1/Institutions", institution);

    return response.data;
  } catch (error) {
    throw new Error("Falha na conexão com a API de criação de instituição");
  }
};

export const updateInstitution = async (institution) => {
  try {
    const response = await api.client.patch(
      "api/v1/UpdateInstitution",
      institution
    );

    return response.data;
  } catch (error) {
    throw new Error("Falha na conexão com a API de criação de instituição");
  }
};

export const updateUser = async (user) => {
  try {
    const response = await api.client.patch("api/v1/UpdateUser", user);

    return response.data;
  } catch (error) {
    throw new Error("Falha na conexão com a API de atualização de usuário");
  }
};

export const deleteUser = async (userId) => {
  try {
    const response = await api.client.delete("api/v1/DeleteUser", {
      data: {
        userId: userId
      }
    });

    return response.data;
  } catch (error) {
    console.log('error', error)
    throw new Error("Falha na conexão com a API de atualização de usuário");
  }
};

/** Valida o token de convite e retorna email, mantenedoraName, institutionName */
export const validateInvite = async (token) => {
  try {
    const response = await api.client.get("api/v1/invite/validate", {
      params: { token }
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 410) {
      return { valid: false, code: error.response.data?.code, message: error.response.data?.message };
    }
    if (error.response?.status === 404) {
      return { valid: false, code: "TokenInvalido", message: error.response.data?.message || "Link inválido." };
    }
    throw error;
  }
};

/** Conclui o cadastro a partir do convite (firstName, lastName, password, phoneNumber?) */
export const completeInvite = async (payload) => {
  const response = await api.client.post("api/v1/invite/complete", payload);
  return response.data;
};
